// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { browserHistory } from '@americanexpress/one-app-router';
// eslint-disable-next-line no-unused-vars
import { FxComponentWrapper, FxJourneyCompletionPage, callFxgApi } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';
import { apiPaths, routes } from '../../../constants/paths';
import actionStatus from '../../../constants/actionStatus';
import { getActionHeading } from '../../../utils/journeyResponseUtil';
import labels from '../../../constants/labels';

const UpdateContactReponse = ({
  updatedContact = {},
  performAnotherActionButtonTxt,
  action,
}) => {
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const [isApiCallCompleted, setIsApiCallCompleted] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [heading, setHeading] = useState('');

  const subHeading = (
    <p className="dls-gray-05">
      <span className="font-weight-bold">{`${labels.CONTACT_NM}: `}</span>
      {updatedContact.userFullName}
    </p>
  );

  useEffect(() => {
    setHeading(getActionHeading(action, submitStatus));
  }, [action, submitStatus]);

  const updateContact = async () => {
    setIsApiCallCompleted(false);
    const requestBody = {
      userEmailId: updatedContact.userEmailId,
      userFirstName: updatedContact.userFirstName,
      userFullName: updatedContact.userFullName,
      userLastName: updatedContact.userLastName,
      countryId: updatedContact.countryId,
    };
    const { hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.updateContactDetails}`,
      'PUT',
      requestBody
    );
    // if replication is success show success messsage
    if (!hasErrors) {
      setSubmitStatus(actionStatus.SUCCESS);
    } else {
      setSubmitStatus(actionStatus.FAILED);
    }
    setIsApiCallCompleted(true);
  };

  useEffect(() => {
    const updateContactApi = async () => {
      await updateContact();
    };
    updateContactApi();
  }, []); // updateContact depends on props/state that won't change

  const onHomeButtonClick = () => {
    browserHistory.push(routes.home);
  };

  const onPrimaryButtonClick = () => {
    window.location.reload();
  };

  const actions = (
    <div className="margin-4-t">
      <ButtonSecondary
        className="margin-responsive-r"
        onClick={onHomeButtonClick}
      >
        Go to Homepage
      </ButtonSecondary>
      <ButtonPrimary onClick={onPrimaryButtonClick}>
        {performAnotherActionButtonTxt}
      </ButtonPrimary>
    </div>
  );

  return (
    <div className="margin-4-t">
      <FxComponentWrapper
        isError={false}
        isLoading={!isApiCallCompleted}
        loadedComponent={(
          <FxJourneyCompletionPage
            heading={heading}
            subHeading={subHeading}
            status={submitStatus}
            actions={actions}
          />
        )}
      />
    </div>
  );
};

UpdateContactReponse.propTypes = {
  updatedContact: PropTypes.shape({
  }).isRequired,
  performAnotherActionButtonTxt: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default UpdateContactReponse;
